var React = require('react');

function AddItem (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(1,0,0,1,-260,-32)"},React.createElement("g",{"transform":"matrix(1,0,0,1,-25.4947,-5.14393)"},React.createElement("path",{"d":"M299.5,39.5C299.5,38.672 298.828,38 298,38C297.172,38 296.5,38.672 296.5,39.5L296.5,48.5L287.5,48.5C286.672,48.5 286,49.172 286,50C286,50.828 286.672,51.5 287.5,51.5L296.5,51.5L296.5,60.5C296.5,61.328 297.172,62 298,62C298.828,62 299.5,61.328 299.5,60.5L299.5,51.5L308.5,51.5C309.328,51.5 310,50.828 310,50C310,49.172 309.328,48.5 308.5,48.5L299.5,48.5L299.5,39.5Z","style":{"fill":"rgb(39,55,122)"}}))));
}

AddItem.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 25 26","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = AddItem;

AddItem.default = AddItem;
